import React, { useEffect, useState } from 'react'
import Header1 from '../../../images/responsive-navigation-bar-using-react-js.png'
import Header2 from '../../../images/overlaynavigationbar.png'
import Header3 from '../../../images/dropdownnavbar.png'
import { FaEye } from "react-icons/fa";
import { CiLink } from "react-icons/ci";
import { FaYoutube } from "react-icons/fa6";
import './header.scss'
import { IoClose } from 'react-icons/io5';

const Header = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedHeader, setSelectedHeader] = useState(null);
    const [header, setHeader] = useState([])
    const [error, setError] = useState()

    const getAllHeader = async () => {
        try {
            const resp = await fetch("/data/db.json"); // Load JSON locally
            if (!resp.ok) throw new Error(resp.statusText);
            const data = await resp.json();
            setHeader(data.HeaderData); // Use "HeaderData" key
        } catch (err) {
            setError(`Error: ${err.message}`);
        }
    };


    useEffect(() => {
        getAllHeader()
    })


    // Function to handle video display
    const handleWatchVideo = (videoUrl) => {
        setSelectedVideo(videoUrl);
    };

    // Function to close the video popup
    const handleClosePopup = () => {
        setSelectedVideo(null);
    };
    
    
    const handleDownloadCode = (downloadUrl) => {
        window.open(downloadUrl, '_blank');
    };
    
    
    // Function to close the Preview popup
    const handleHeaderClosePopup = () => {
        setSelectedHeader(null);
    };


    return (
        <>
            <div className="mainHeaderReactCodes">
                <div className="subHeaderReactCodes">
                    {header.map((item, index) => (
                        <div key={index} className="HeaderReactCodes">
                            <div className="listHeaderReactCodes1 listHeaderReactCodesImg">
                                <img src={item.HeaderImage} alt={item.HeaderTitle} />
                                <h4 onClick={() => handleDownloadCode(item.HeaderDownload)}>{item.HeaderTitle}</h4>
                            </div>
                            <div className="listHeaderReactCodes2">
                                <div className="HeaderCodeBtns">
                                    <button onClick={() => handleDownloadCode(item.HeaderDownload)} target="_blank" rel="noopener noreferrer"><CiLink className='HeaderIcons' /></button>
                                    <button onClick={() => handleWatchVideo(item.HeaderVideoWatch)}><FaYoutube className='HeaderIcons' /></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {selectedHeader && (
                    <div className="HeaderSourceCodePopup">
                        <div className="subHeaderSourceCodePopup">
                            <span className='HeaderSourceCodeCloseButton' onClick={handleHeaderClosePopup}><IoClose /></span>
                            <iframe src={selectedHeader}></iframe>
                        </div>
                    </div>
                )}


                {/* Popup for Video (only one at a time) */}
                {selectedVideo && (
                    <div className="popup">
                        <div className="popup-content">
                            <span className="header-close-button" onClick={handleClosePopup}><IoClose /></span>
                            <iframe
                                src={selectedVideo}
                                title="Header Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default Header